module.exports = __webpack_public_path__ + "static/media/landscape.a570b5df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landscape.png
// module id = 329
// module chunks = 0